import { SelectableSearchParameter } from './selectable-search-parameter';

export enum SubProjectTypeSearchParameter {
  PROJECT = 'PROJECT',
  WINDOWSTICKER = 'WINDOWSTICKER',
  IPBOARD = 'IPBOARD'
}

export const SUB_PROJECT_TYPE_SEARCH_PARAMETER_CHOICES: SelectableSearchParameter<
  SubProjectTypeSearchParameter
>[] = [
  { key: SubProjectTypeSearchParameter.PROJECT, display: 'Project' },
  { key: SubProjectTypeSearchParameter.WINDOWSTICKER, display: 'Raamsticker' },
  { key: SubProjectTypeSearchParameter.IPBOARD, display: 'IP-bord' }
];
